import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d47831f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "container-lg p-0 p-lg-auto" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-uppercase m-0 mb-3 text-center mt-4 mt-xl-5 heading" }, [
  /*#__PURE__*/_createTextVNode("Life GOES ON, even when the "),
  /*#__PURE__*/_createElementVNode("br", { class: "d-none d-sm-block d-xl-none" }),
  /*#__PURE__*/_createTextVNode(" power goes off!")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-md-3 mb-xl-4 text-center heading-blurb" }, "Trusted South African solutions for unique needs - so you can have Power for Peace of Mind. ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex col-12 flex-wrap h-100 py-lg-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-4 mb-xl-5 col-md-11 text-center text-sm-start" }, "Magneto Portable Power Stations will provide you with electricity during load-shedding, power outages, or for outdoor use where no power is available."),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-4 mb-xl-5 col-md-11 text-center text-sm-start" }, "In a nutshell, a Power Station is a potent, all-in-one battery and inverter, able to store electricity via charging, and supply it to your devices as you need it."),
  /*#__PURE__*/_createElementVNode("p", { class: "col-md-11 text-center text-sm-start" }, "Our Power Stations are designed with South Africans in mind - with our familiar 3-prong 220V plug sockets, so no adaptors are needed, and from 6 – 13 outlet ports to run your devices at the same time*.")
], -1))
const _hoisted_7 = { class: "d-flex col-12 flex-wrap h-100 py-lg-3 justify-content-center justify-content-sm-start" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-4 mb-xl-5 col-md-11 text-center text-sm-start" }, "Power your lights, TV, fridge, internet router, computer, fans, and more.* Charge your laptop, smart phone, and tablet - all from one versatile, portable backup power solution!", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-4 mb-xl-5 col-md-11 text-center text-sm-start" }, "Select from our range of Power Stations according to your specific power needs, so life can keep going… even when the power goes off.", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-4 mb-xl-5 col-md-11 text-center text-sm-start disclaimer-text" }, "*Devices must not exceed the maximum capacity of the Power Station.", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary px-4 px-lg-5 py-1 py-lg-2" }, "View the range now", -1))
const _hoisted_12 = { class: "container-lg p-0 p-lg-auto pt-5" }
const _hoisted_13 = { class: "p-0 p-sm-auto register-warranty" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CarouselBanner = _resolveComponent("CarouselBanner")!
  const _component_InfoSection = _resolveComponent("InfoSection")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_RegisterWarrantyBanner = _resolveComponent("RegisterWarrantyBanner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CarouselBanner, {
        uniqueId: "homeBanner",
        images: _ctx.homeBannerImages
      }, null, 8, ["images"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createVNode(_component_InfoSection, {
        class: "mt-4 mt-md-5",
        imageSrc: _ctx.introSection1.imageSrc,
        imageAlt: _ctx.introSection1.imageAlt,
        imageLocation: _ctx.introSection1.imageLocation,
        videoSrc: _ctx.introSection1.videoSrc
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["imageSrc", "imageAlt", "imageLocation", "videoSrc"]),
      _createVNode(_component_InfoSection, {
        class: "my-4",
        imageSrc: _ctx.introSection2.imageSrc,
        imageAlt: _ctx.introSection2.imageAlt,
        imageLocation: _ctx.introSection2.imageLocation,
        videoSrc: _ctx.introSection2.videoSrc
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            _createVNode(_component_router_link, {
              class: "text-decoration-none",
              to: { name: 'ProductRange' }
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["imageSrc", "imageAlt", "imageLocation", "videoSrc"])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_CarouselBanner, {
        uniqueId: "productBanner",
        images: _ctx.productBannerImages
      }, null, 8, ["images"])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_RegisterWarrantyBanner)
    ])
  ]))
}